import { SeoWrapper } from '@/contexts/Seo/SeoWrapper';

import { ROUTES_INPUT } from '../config';
import { AllRouteKeys } from '../seoConfig';

import type { RouteConfig } from '../types';
import type { RouteObject } from 'react-router';

export function buildRouteInfoMap() {
  const pathToInfo = new Map<string, { key: AllRouteKeys; isServiceRoute: boolean }>();

  Object.keys(ROUTES_INPUT).forEach((system) => {
    const routesGroup = ROUTES_INPUT[system as keyof typeof ROUTES_INPUT];
    if (!routesGroup) return;

    Object.keys(routesGroup).forEach((key) => {
      const cfg = routesGroup[key as keyof typeof routesGroup] as RouteConfig;

      const partialPath = cfg.path.replace(/^\//, '');

      pathToInfo.set(partialPath, {
        key: key as AllRouteKeys,
        isServiceRoute: cfg.isServiceRoute ?? false,
      });
    });
  });

  return pathToInfo;
}

export function wrapRoutesWithSeo(
  routes: RouteObject[],
  routeInfoMap: Map<string, { key: AllRouteKeys; isServiceRoute: boolean }>,
): RouteObject[] {
  return routes.map((route) => {
    const newRoute = { ...route };

    if (newRoute.children) {
      newRoute.children = wrapRoutesWithSeo(newRoute.children, routeInfoMap);
    }

    if (newRoute.element) {
      let path = newRoute.path ?? '';
      if (newRoute.index) {
        path = '/';
      }

      const partialPath = path.replace(/^\//, '');
      const info = routeInfoMap.get(partialPath);

      if (info && !info.isServiceRoute) {
        newRoute.element = <SeoWrapper pageKey={info.key}>{newRoute.element}</SeoWrapper>;
      }
    }

    return newRoute;
  });
}
